module.exports = __webpack_public_path__ + "media/images/request-venue-bg-img-27685c97faf3f1ab93d3ee681ff616b2.png";